import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, map, Observable, take } from "rxjs";
import { StrictHttpResponse } from 'src/api/strict-http-response';
import { ToastrService } from 'ngx-toastr';
import { MapLayerItem } from 'src/api/models';
import { MapService } from 'src/api/services';
import { ApplicationConfigService } from './application-config.service';

@Injectable()
export class MapLayerTableService {

  public remoteData: Observable<MapLayerItem[]>;
  private _remoteData: BehaviorSubject<MapLayerItem[]>;
  public results: MapLayerItem[];
  public loading: boolean;

  constructor(
    private readonly service: MapService,
    private readonly app: ApplicationConfigService,
    private toasterService: ToastrService) {

    this._remoteData = new BehaviorSubject<MapLayerItem[]>([]);
    this.remoteData = this._remoteData.asObservable();

  }

  filter(item: MapLayerItem) {
    if (item) this._remoteData.next(this.results.filter(d => d.mapLayerId == item.mapLayerId));
    else this._remoteData.next(this.results);
  }

  get() {
    this.loading = true;
    this.service.MapGetMapLayers(this.app.customerId).subscribe(result => {
      console.log("Get Layers for " + this.app.customerId);
      this.loading = false;
      this.results = result;
      this._remoteData.next(result);
    });
  }

  remove(item: MapLayerItem) {
    this.loading = true;
    return this.service.MapDeleteMapLayer(item).subscribe(s => {
      this.toasterService.success("MapLayerItem Removed");
      this.get();
    }, e => {
      this.toasterService.error("MapLayerItem Not Removed");
    });
  }

  update(item: MapLayerItem) {
    this.loading = true;
    return this.service.MapUpdateMapLayer(item).subscribe(s => {
      this.toasterService.success("MapLayerItem Updated");
      this.get();
    }, e => {
      this.toasterService.error("MapLayerItem Not Updated");
    });
  }

  add(item: MapLayerItem) {
    this.loading = true;
    return this.service.MapAddMapLayer(item).subscribe(s => {
      this.toasterService.success("MapLayerItem Added");
      this.get();
    }, e => {
      this.toasterService.error("MapLayerItem Not Added");
    });
  }

  getLayerByName(name: string): Observable<MapLayerItem | undefined> {
    // 1. Trigger the load if we don't have data yet
    if (!this.results || this.results.length === 0) {
      this.get();
    }

    return this.remoteData.pipe(
      filter(items => items && items.length > 0),
      map(items => items.find(layer => layer.layerName === name)),
      take(1)
    );
  }

  getLayerById(id: number): Observable<MapLayerItem | undefined> {
    // 1. Trigger the load if we don't have data yet
    if (!this.results || this.results.length === 0) {
      this.get();
    }

    return this.remoteData.pipe(
      filter(items => items && items.length > 0),
      map(items => items.find(layer => layer.mapLayerId === id)),
      take(1)
    );
  }
}
